export default __webpack_public_path__ + "static/media/user_updated.f6401225.png";